import css from 'styled-jsx/css';
import { common } from '../../../theme/theme';

const style = css`
  .trip-return-edit-modal {
    width: 380px;
    padding: 16px;
  }
  .label {
    font-size: 14px;
  }
  .trip-return-edit-modal-inputs {
    width: 100%;
  }
  .trip-return-edit-wrapper,
  .reason-selector-wrapper {
    margin-bottom: 8px;
  }
  .trip-return-edit-modal :global(.submit-button) {
    margin-top: 24px;
    ${common.button}
    ${common.submitButton}
  }
  .trip-return-edit-modal :global(.cancel-button) {
    ${common.button}
    ${common.cancelButton}
  }
`;

export default style;
